module.exports = __webpack_public_path__ + "img/avatar.e3d0779f.jpg";